/**
 * Calculate which handle to use based on the angle between two nodes
 */
const getHandleForPosition = (
  sourcePos: { x: number; y: number },
  targetPos: { x: number; y: number },
): { source: string; target: string } => {
  const dx = targetPos.x - sourcePos.x;
  const dy = targetPos.y - sourcePos.y;
  const angle = Math.atan2(dy, dx) * (180 / Math.PI);

  // Determine source handle based on angle FROM source TO target
  let sourceHandle: string;
  if (angle >= -45 && angle < 45) {
    sourceHandle = "source-right";
  } else if (angle >= 45 && angle < 135) {
    sourceHandle = "source-bottom";
  } else if (angle >= 135 || angle < -135) {
    sourceHandle = "source-left";
  } else {
    sourceHandle = "source-top";
  }

  // Determine target handle (opposite of source direction)
  let targetHandle: string;
  if (angle >= -45 && angle < 45) {
    targetHandle = "target-left";
  } else if (angle >= 45 && angle < 135) {
    targetHandle = "target-top";
  } else if (angle >= 135 || angle < -135) {
    targetHandle = "target-right";
  } else {
    targetHandle = "target-bottom";
  }

  return { source: sourceHandle, target: targetHandle };
};

export default getHandleForPosition;
